import React from 'react';
import {Row} from 'react-bootstrap';
import {TileWithDetailComponent} from "./TileWithDetailComponent";

const TileList = props => {
    
    const {
        className,
        primaryKey,
        actions: actionsCallback,
        tileUrl = (item) => null,
        data = [],
        emptyDataMessage = null,
        ...tileProps
    } = props;
    
    const {
        colSize = 4,
        xs, sm, md, lg,
        ellipsis,
        caption,
        noIcon,
        showComplete,
        subtitle,
        onClick,
        tileDetailComponent,
    } = tileProps;

    return (
        <Row xs={12} className={"tile-list" + (className ? ` ${className}` : '')}>
            {
                data?.length ? data.map((item, index) =>
                    (
                        <TileWithDetailComponent
                            key={item[primaryKey] ?? item.id ?? `tile-without-id-${index}`}
                            
                            item={item}
                            caption={caption}
                            subtitle={subtitle}
                            colSize={colSize}
                            xs={xs}
                            sm={sm}
                            md={md}
                            lg={lg}
                            ellipsis={ellipsis}
                            noIcon={noIcon}
                            showComplete={showComplete}
                            
                            url={tileUrl?.(item) ?? null}
                            onClick={onClick}
                            
                            actions={actionsCallback?.(item)}
                            tileDetailComponent={tileDetailComponent}
                        />
                    )
                ) : emptyDataMessage
            }
        </Row>
    )
};

export default TileList;
